module.exports = __webpack_public_path__ + "static/img/1-2.4b0801c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1-2.jpg
// module id = XRiV
// module chunks = 0